<template>
  <div
    class="content has-text-centered"
    :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
  >
    <div class="columns">
      <div class="column is-half">
        <table class="table is-striped">
          <tbody>
            <tr>
              <td>{{$t('email').tTitle()}}</td>
              <td>{{User.info.email}}</td>
            </tr>
            <tr>
              <td>{{$t('username').tTitle()}}</td>
              <td>{{User.info.username}}</td>
            </tr>
            <tr>
              <td>{{$t('company_name').tTitle()}}</td>
              <td>{{User.info.client.company_name}}</td>
            </tr>
            <tr>
              <td>{{$t('website').tTitle()}}</td>
              <td>{{User.info.client.website}}</td>
            </tr>
            <tr>
              <td>{{$t('first_name').tTitle()}}</td>
              <td>{{User.info.firstname}}</td>
            </tr>
            <tr>
              <td>{{$t('last_name').tTitle()}}</td>
              <td>{{User.info.lastname}}</td>
            </tr>
            <tr>
              <td>{{$t('date_of_birth').tTitle()}}</td>
              <td>{{$formatDate(User.info.date_of_birth)}}</td>
            </tr>
            <tr>
              <td>{{$t('gender').tTitle()}}</td>
              <td>{{User.info.gender}}</td>
            </tr>
            <tr>
              <td>{{$t('phone').tTitle()}}</td>
              <td>{{User.info.phone}}</td>
            </tr>
            <tr>
              <td>{{$t('country').tTitle()}}</td>
              <td>{{User.info.country_code}}</td>
            </tr>
            <tr>
              <td>{{$t('address').tTitle()}}</td>
              <td>{{User.info.address}}</td>
            </tr>
            <tr>
              <td>{{$t('year_moved_to_address').tTitle()}}</td>
              <td>{{User.info.year_moved_to_address}}</td>
            </tr>
            <tr>
              <td>{{$t('post_code').tTitle()}}</td>
              <td>{{User.info.post_code}}</td>
            </tr>
            <tr>
              <td>{{$t('selected_currency').tTitle()}}</td>
              <td>{{User.wallet.currency.toUpperCase()}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- <ul class="has-text-left">
		<li><strong>{{$t('username').tTitle()}}</strong>: {{User.info.username}}</li>
		<li><strong>{{$t('company_name').tTitle()}}</strong>: {{User.info.client.company_name}}</li>
		<li><strong>{{$t('website').tTitle()}}</strong>: {{User.info.client.website}}</li>
		<li><strong>{{$t('first_name').tTitle()}}</strong>: {{User.info.firstname}}</li>
		<li><strong>{{$t('last_name').tTitle()}}</strong>: {{User.info.lastname}}</li>
		<li><strong>{{$t('date_of_birth').tTitle()}}</strong>: {{$formatDate(User.info.date_of_birth)}}</li>
		<li><strong>{{$t('gender').tTitle()}}</strong>: {{User.info.gender}}</li>
		<li><strong>{{$t('phone').tTitle()}}</strong>: {{User.info.phone}}</li>
		<li><strong>{{$t('country').tTitle()}}</strong>: {{User.info.country_code}}</li>
		<li><strong>{{$t('address').tTitle()}}</strong>: {{User.info.address}}</li>
		<li><strong>{{$t('year_moved_to_address').tTitle()}}</strong>: {{User.info.year_moved_to_address}}</li>
		<li><strong>{{$t('post_code').tTitle()}}</strong>: {{User.info.post_code}}</li>
		<li><strong>{{$t('selected_currency').tTitle()}}</strong>: {{User.wallet.currency.toUpperCase()}}</li>
    </ul>-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      // lang:null,
    }
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
    }),
  },
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
// @import "../assets/css/variables";
table {
  tr td:first-of-type {
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// PersonalInformation.vue?6123225e